import React from 'react'
import Tooltip from 'lib/components/tooltip'
import Icon from 'lib/components/icon'

export default function InfoLabel({ label, overlay, scrollParent }) {
  if (overlay) {
    return (
      <span>
        {label}
        <Tooltip el="span" overlay={overlay} scrollParent={scrollParent}>
          <Icon type="info" width="16px" height="16px" />
        </Tooltip>
      </span>
    )
  }
  return <span>{label}</span>
}



// WEBPACK FOOTER //
// ./src/components/info-label.js